const options = [{
    value: 'S1',
    label: 'S1'
  },
  {
    value: 'S1-A',
    label: 'S1-A'
  },
  {
    value: 'S1-B',
    label: 'S1-B'
  },

  {
    value: 'S2',
    label: 'S2'
  },
  {
    value: 'S2-A',
    label: 'S2-A'
  },
  {
    value: 'S2-B',
    label: 'S2-B'
  },

  {
    value: 'S3',
    label: 'S3'
  },
  {
    value: 'S3-A',
    label: 'S3-A'
  },
  {
    value: 'S3-B',
    label: 'S3-B'
  },

  {
    value: 'S4 MPC',
    label: 'S4 MPC'
  },
  {
    value: 'S4 MPC-A',
    label: 'S4 MPC-A'
  },
  {
    value: 'S4 MPC-B',
    label: 'S4 MPC-B'
  },
  {
    value: 'S4 MCB',
    label: 'S4 MCB'
  },
  {
    value: 'S4 MCB-A',
    label: 'S4 MCB-A'
  },
  {
    value: 'S4 MCB-B',
    label: 'S4 MCB-B'
  },
  {
    value: 'S4 PCB',
    label: 'S4 PCB'
  },
  {
    value: 'S4 PCB-A',
    label: 'S4 PCB-A'
  },
  {
    value: 'S4 PCB-B',
    label: 'S4 PCB-B'
  },
  {
    value: 'S4  PCM',
    label: 'S4 PCM'
  },
  {
    value: 'S4  PCM-A',
    label: 'S4 PCM-A'
  },
  {
    value: 'S4  PCM-B',
    label: 'S4 PCM-B'
  },
  {
    value: 'S4 PCM',
    label: 'S4 PCM'
  },
  {
    value: 'S4 PCM-A',
    label: 'S4 PCM-A'
  },
  {
    value: 'S4 PCM-B',
    label: 'S4 PCM-B'
  },

  {
    value: 'S5 MPC',
    label: 'S5 MPC'
  },
  {
    value: 'S5 MPC-A',
    label: 'S5 MPC-A'
  },
  {
    value: 'S5 MPC-B',
    label: 'S5 MPC-B'
  },
  {
    value: 'S5 MCB',
    label: 'S5 MCB'
  },
  {
    value: 'S5 MCB-A',
    label: 'S5 MCB-A'
  },
  {
    value: 'S5 MCB-B',
    label: 'S5 MCB-B'
  },
  {
    value: 'S5 PCB',
    label: 'S5 PCB'
  },
  {
    value: 'S5 PCB-A',
    label: 'S5 PCB-A'
  },
  {
    value: 'S5 PCB-B',
    label: 'S5 PCB-B'
  },
  {
    value: 'S5 PCM',
    label: 'S5 PCM'
  },
  {
    value: 'S5 PCM-A',
    label: 'S5 PCM-A'
  },
  {
    value: 'S5 PCM-B',
    label: 'S5 PCM-B'
  },
  {
    value: 'S5 PCM',
    label: 'S5 PCM'
  },
  {
    value: 'S5 PCM-A',
    label: 'S5 PCM-A'
  },
  {
    value: 'S5 PCM-B',
    label: 'S5 PCM-B'
  },

  {
    value: 'S6 MPC',
    label: 'S6 MPC'
  },
  {
    value: 'S6 MPC-A',
    label: 'S6 MPC-A'
  },
  {
    value: 'S6 MPC-B',
    label: 'S6 MPC-B'
  },
  {
    value: 'S6MCB',
    label: 'S6MCB'
  },
  {
    value: 'S6 MCB-A',
    label: 'S6 MCB-A'
  },
  {
    value: 'S6 MCB-B',
    label: 'S6 MCB-B'
  },
  {
    value: 'S6 PCB',
    label: 'S6 PCB'
  },
  {
    value: 'S6 PCB-A',
    label: 'S6 PCB-A'
  },
  {
    value: 'S6 PCB-B',
    label: 'S6 PCB-B'
  },
  {
    value: 'S6 PCM',
    label: 'S6 PCM'
  },
  {
    value: 'S6 PCM-A',
    label: 'S6 PCM-A'
  },
  {
    value: 'S6 PCM-B',
    label: 'S6 PCM-B'
  },
  {
    value: 'S6 PCM',
    label: 'S6 PCM'
  },
  {
    value: 'S6 PCM-A',
    label: 'S6PCM-A'
  },
  {
    value: 'S6 PCM-B',
    label: 'S6 PCM-B'
  }
]
export const optionGender = [{
  value: 'M',
  label: 'Male'
}, {
  value: 'F',
  label: 'Female'
}]
export default options